<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { saveUser } from "./api";

const router = useRouter();
const saving = ref(false), success = ref(false), error = ref(""), validationError = ref("");
const form = ref({ customer_id: "", name: "", display_name: "", company: "", department: "", job_title: "", job_classification: "", level: "", dob: "", hiring_date: "", proxy_number: "" });

function validate() {
  const f = form.value;
  if (!f.customer_id.trim()) return "Employee Number is required.";
  if (!f.name.trim()) return "Official Name is required.";
  if (!f.company.trim()) return "Company is required.";
  if (!f.department.trim()) return "Department is required.";
  if (!f.job_title.trim()) return "Job Title is required.";
  return "";
}

async function create() {
  success.value = false; error.value = ""; validationError.value = "";
  const msg = validate();
  if (msg) { validationError.value = msg; return; }
  const f = form.value;
  const payload = { name: f.name, display_name: f.display_name, customer_id: f.customer_id, dob: f.dob, company: f.company, department: f.department, job_title: f.job_title, job_classification: { job_code: f.job_classification?.split("-")[0] || "", job_description: f.job_classification?.split("-")[1] || "" }, level: f.level, hiring_date: f.hiring_date, proxy_number: f.proxy_number };
  saving.value = true;
  try { await saveUser(payload); success.value = true; setTimeout(() => router.push({ name: "users" }), 800); }
  catch { error.value = "Error occurred. Please try again."; }
  finally { saving.value = false; }
}
</script>

<template>
  <section>
    <VBtn variant="text" prepend-icon="mdi:arrow-left" class="mb-4" @click="router.push({ name: 'users' })">Back</VBtn>
    <h1 class="text-h5 mb-4">Add User</h1>
    <VCard class="pa-4" max-width="800">
      <VAlert v-if="error" type="error" class="mb-4">{{ error }}</VAlert>
      <VAlert v-if="success" type="success" class="mb-4">User created. Redirecting…</VAlert>
      <form @submit.prevent="create">
        <VRow>
          <VCol cols="12" md="6"><VTextField v-model="form.customer_id" label="Employee Number" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.level" label="Level" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.name" label="Official Name" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.display_name" label="Preferred Name" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.company" label="Company" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.department" label="Department" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.job_title" label="Job Title" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.job_classification" label="Job Classification" placeholder="CODE-DESCRIPTION" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.dob" label="Date of Birth" type="datetime-local" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.hiring_date" label="Hiring Date" type="datetime-local" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.proxy_number" label="Proxy Number" /></VCol>
        </VRow>
        <VAlert v-if="validationError" type="warning" class="mt-4 mb-2">{{ validationError }}</VAlert>
        <div class="d-flex gap-2 mt-4">
          <VBtn type="submit" :loading="saving">Add User</VBtn>
          <VBtn variant="tonal" @click="router.push({ name: 'users' })">Cancel</VBtn>
        </div>
      </form>
    </VCard>
  </section>
</template>
